import "./App.css";
import "animate.css";
import {
  Outlet,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ThemeProvider } from "./Context/ThemeContext/ThemeContext";
import { HelmetProvider } from "react-helmet-async";
import Background from "./Pages/Shared/Theme/Background/Background";
import Home from "./Pages/Home/Home";
import Navbar from "./Pages/Shared/Navbar/Navbar";
import Blog from "./Pages/Blog/Blog";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import Footer from "./Pages/Shared/Footer/Footer";
import Particle from "./Particle/Particle";
import AnimatedCursor from "react-animated-cursor";
import NotFound from "./Pages/NotFound/NotFound";
import { useEffect, useState } from "react";
import Loader from "./Pages/Shared/Loader/Loader";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ScrollToTop from "react-scroll-to-top";
import Login from "./Pages/Auth/Login";
import SignUp from "./Pages/Auth/SignUp";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./Pages/Auth/firebase.init";
import Achivement from "./Pages/Achivement/Achivement";
import Licenseing from "./Pages/licenseing/Licenseing";
import "animate.css";
import Experience from "./Pages/Experience/Experience";
import PrivacyPolicy from "./Pages/Privacy-Policy/PrivacyPolicy";
import Company from "./Pages/Company/Company";
import Video from "./Pages/Video/Video";
import Audio from "./Pages/Shared/Audio/Audio";
import AllBlog from "./Pages/Blog/AllBlog";
import Photos from "./Pages/Shared/Photos/Photos";
import Recommendation from "./Pages/Recommendation/Recommendation";
import Documentation from "./Pages/Documentation/Documentation";
import Map from "./Pages/Map/Map";
import BlogForm from "./Pages/Blog/BlogForm";
import MessengerChatBot from "./Pages/Home/MessengerChatBot";
import Thesis from "./Pages/Home/Projects/Thesis/Thesis";
import Terms from "./Pages/Terms/Terms";
import Research from "./Pages/Research/Research";
import AllBlogs from "./Pages/Dashboard/articles/page";
import WriteBlog from "./Pages/Dashboard/articles/write/page";
import DashboardLayout from "./Pages/Dashboard/DashboardLayout";
import UpdateBlog from "./Pages/Dashboard/articles/UpdateBlog/page";
import SingleArticle from "./Pages/Blog/SingleBlog";
import AdminRoute from "./Pages/Dashboard/AdminRoute";
import Categories from "./Pages/Category/page";
import SubCategories from "./Pages/Category/SubCategory";

function App() {
  const Layout = () => {
    const [loading,
      setLoading] = useState(true);

    const [change, setChange] = useState(false);
    useEffect(() => {
      setTimeout(() => {
        setChange(true);
        setTimeout(() => {
          setLoading(false);
        }, 2500);
      }, 1000);
    }, []);
    if (loading) {
      return <Loader loading={loading} change={change} />;
    }
    return (
      <div>
        <ThemeProvider>
          <HelmetProvider>

          
            <AnimatedCursor innerSize={12} outerSize={10} color="67, 56, 202" />
            <Particle/> 
            <ScrollToTop smooth color="white" style={{ backgroundColor: "#6366F1", bottom: '130px' }} />
            <MessengerChatBot />
            <Navbar />
            <Background>
              <Outlet />
            </Background>
            <Footer />
          </HelmetProvider>
        </ThemeProvider>

      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "category",
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <Categories />
            },
            {
              path: ":id",
              element: <SubCategories />
            }
          ]
        },
        {
          path: "blog",
          element: <Blog />,
        },
        {
          path: 'all-blog',
          element: <AllBlog />
        },
        {
          path: "blog/:id",
          element: <SingleArticle />,
        },
        {
          path: "feedback",
          element: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          ),
        },
        {
          path: "dashboard",
          element: <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>,
          children: [
            {
              index: true,
              element: <Dashboard />,
            },
            {
              path: 'blogs',
              element: <AdminRoute><AllBlogs /></AdminRoute>
            },
            {
              path: 'write',
              element: <AdminRoute><WriteBlog /> </AdminRoute>
            },
            {
              path: 'blogs/:id',
              element: <AdminRoute><UpdateBlog /></AdminRoute>
            },
            {
              path: 'feedback',
              element: <Dashboard />,
            }
          ]
        },
        {
          path: "about",
          element: <About />,
        },
        {
          path: "contact",
          element: <Contact />,
        },
        {
          path: "thesis",
          element: <Thesis />,
        },
        {
          path: "achivement",
          element: <Achivement />,
        },
        {
          path: "experience",
          element: <Experience />,
        },
        {
          path: "company",
          element: <Company />,
        },
        {
          path: "video",
          element: <Video />,
        },
        {
          path: "audio",
          element: <Audio />,
        },
        {
          path: "photos",
          element: <Photos />,
        },
        {
          path: "recommendations",
          element: <Recommendation />,
        },
        {
          path: "documentations",
          element: <Documentation />,
        },
        {
          path: "maps",
          element: <Map />,
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "research",
          element: <Research />,
        },
        {
          path: "terms",
          element: <Terms />,
        },
        {
          path: "licenseing",
          element: <Licenseing />,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "signup",
          element: <SignUp />,
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;

const ProtectedRoute = ({ children }) => {
  const [user] = useAuthState(auth);
  if (user) {
    return children;
  } else {
    return <Login />;
  }
};
